<template>
  <b-container fluid>
    <b-modal ref="saveWarning" hide-footer>
      {{ warningMessage }}

      <div style="text-align: right" class="mt-4">
        <b-button
          class="mx-2"
          variant="danger"
          @click="$refs.saveWarning.hide()"
          >{{ $cte("common.cancel") }}
        </b-button>
        <b-button
          class="mx-2"
          variant="success"
          @click="
            () => {
              $refs.saveWarning.hide();
              save(true);
            }
          "
          >{{ $cte("common.saveAnyway") }}
        </b-button>
      </div>
    </b-modal>

    <PageHeader :title="$cte('wage.employeeHeader')" :enable-back-link="true" />
    <b-tabs class="mt-3" style="width: 100% !important;" lazy>
      <b-tab
          title="Törzsadat"
          class=" pt-1"
          style=""
      >

        <employee-torzsadat :employee-id="userData.id" />
      </b-tab>
      <b-tab
        title="Szabadság"
        v-if="
          userData.employmentModeId &&
          [2902, 2903, 2904, 2906].includes(userData.employmentModeId)
        "
        class="pt-1"
        style=""
      >
        <employee-holiday :employee-id="userData.id" />
      </b-tab>
      <b-tab
        title="Betegszabadság, táppénz"
        v-if="
          userData.employmentModeId &&
          [2902, 2903, 2904, 2906].includes(userData.employmentModeId)
        "
        class=" pt-1"
        style=""
      >
        <employee-sick-leave :employee-id="userData.id" />
      </b-tab>
      <b-tab
          title="Kedvezmény"
          class="pt-1"
          style=""
      >
        <employee-discounts :employee-id="userData.id" />
      </b-tab>
      <b-tab
          title="Dokumentumok"
          class=" pt-1  "
          style=""
      >
        <div
          class="mt-3"
          v-if="userData && userData.id"
        >
          <work-docs
            class="mt-3"
            :user-name="userData.birthName"
            :user-id="userData.id"
          />
        </div>
      </b-tab>
      <b-tab
          title="Kiléptetés"
          class=" pt-1"
          style=""
      >
        <div
          class="mt-3 font-jumper"
          v-if="userData && userData.id"
        >
          <employee-delete :employee-id="userData.id" :employee-name='userData.currentNameLastName + " " + userData.currentNameFirstName' />
        </div>
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import Api from "@/api/server/index";
import WorkDocs from "@/components/WorkDocs";
import { mapGetters } from "vuex";
import PageHeader from "@/components/PageHeader";
import EmployeeHoliday from "@/components/wage/EmployeeHoliday.vue";
import EmployeeSickLeave from "@/components/wage/EmployeeSickLeave.vue";
import EmployeeTorzsadat from "@/components/wage/EmployeeTorzsadat.vue";
import EmployeeDiscounts from "@/components/wage/EmployeeDiscounts.vue";
import EmployeeDelete from "@/components/wage/EmployeeDelete.vue";

export default {
  name: "EditEmployee",
  components: {
    EmployeeDelete,
    EmployeeDiscounts,
    EmployeeTorzsadat,
    EmployeeSickLeave,
    EmployeeHoliday,
    WorkDocs,
    PageHeader,
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  data() {
    return {
      warningMessage: "",
      evIdList: [],

      userData: {
        id: this.$route.params.employeeId,
        employeeType: this.$route.params.type,
        companyId: this.$route.params.companyId,
      },

    };
  },
  methods: {
    navigateBack() {
      let url = "/app/employee/list";
      this.$router.push(url);
    },
  },

  async created() {
    this.evIdList = await Api.getEvIdList(this.getActiveCompany.id).then(
      (resp) => resp.data
    );

    if (this.userData.id) {
      try {
        this.userData = await Api.getEmployeeById(this.userData.id).then(
          (resp) => resp.data
        );
      } catch (err) {
        this.$toast.error({
          title: this.$cte("toast.error"),
          message: this.$cte("toast.error"),
        });
      }
    }

    if (this.getActiveCompany.taxNumber && !this.userData.evTaxNumber) {
      this.userData.evTaxNumber = this.getActiveCompany.taxNumber;
    }
  },
};
</script>

<style scoped>
.is-invalid {
  background-color: #f9e2e2 !important;
}

.rounded-employee-icon {
  width: 150px;
  height: 150px;
  border-radius: 100%;
  text-align: center;
  padding-top: 38px;
  color: white;
  font-size: 56px;
}

@media only screen and (min-width: 750px) {
  .dynamic-profile-picture {
    position: absolute;
    float: right;
    right: 0;
    width: max-content;
  }

  .profile-picture-buttons-display {
    display: flex !important;
  }
}

.card-body {
  padding: 0 !important;
}

.data-wrapper {
  min-height: 60px;
}
</style>
